module.exports = __webpack_public_path__ + "static/media/london.7ab44f9d.png";